import { render, staticRenderFns } from "./FilesTableForMobile.vue?vue&type=template&id=01576ce6&"
import script from "./FilesTableForMobile.vue?vue&type=script&lang=js&"
export * from "./FilesTableForMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports